/**
 * TanStack Query hook for team-story analysis.
 *
 * Backend aggregates ADAPT data and choice patterns across all team
 * members for a completed team-story. While that aggregation is
 * running, the endpoint returns 202 with `{ status: 'processing' }`
 * and this hook polls every 5s until it's ready — same pattern as
 * useAnalysis.js.
 * @module useTeamAnalysis
 */

import { useQuery } from '@tanstack/react-query'
import { teamService } from '../services/teamService'

export function useTeamAnalysis(teamId, teamStoryId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['teamAnalysis', teamId, teamStoryId],
    queryFn: () => teamService.getTeamAnalysis(teamId, teamStoryId),
    enabled: !!teamId && !!teamStoryId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
    refetchInterval: (query) => {
      if (query.state.data?.status === 'processing') return 5000
      return false
    },
  })

  const isProcessing = data?.status === 'processing'
  const analysis = isProcessing ? null : data

  return { analysis, isLoading, isProcessing, error, refetch }
}
